import { Component, OnInit, Input } from '@angular/core';
import {
  AbstractControl,
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

import { EProductTypes } from '../../interfaces';

@Component({
  selector: 'lum-rfq-kit-items-form',
  templateUrl: './rfq-kit-items-form.component.html',
  styleUrls: ['./rfq-kit-items-form.component.scss'],
})
export class RfqKitItemsComponent implements OnInit {
  @Input()
  dialogData :any;

  @Input()
  form :UntypedFormGroup;

  @Input()
  unitMeasures :any = [];

  constructor(private fb :UntypedFormBuilder) {}

  ngOnInit() :void {
    this.onAddItem();
  }

  onRemoveItem(idx :number) :void {
    this.kitItemsControl.removeAt(idx);
  }

  onAddItem(item ?:UntypedFormGroup) :void {
    if (item) {
      this.kitItemsControl.push(item);
    } else {
      this.kitItemsControl.push(
        this.fb.group({
          id: [null],
          sku: [this.fb.group({})],
          productId: [null],
          quantity: [1],
          price: [0],
          originalPrice: [0],
          lineTotal: [0],
          uomId: [null],
        }),
      );
    }
  }

  onAddMultipleItems(rows :number) :void {
    for (let item = 0; item < rows; item++) {
      this.onAddItem();
    }
  }

  onSelectRfq({ rfq } :any, item :AbstractControl) :void {
    const control = item as UntypedFormControl;
    const uoms = rfq.unit_of_measures || [];
    const defaultUomId = uoms ? uoms[0].id : null;

    control.patchValue({
      productId: rfq.id,
      originalPrice: rfq.unit_price,
      price: rfq.unit_price,
      uomId: defaultUomId,
      lineTotal: control.value.quantity * rfq.unit_price,
      sku: this.fb.group({
        sku: rfq.sku,
        product_name: rfq.product_name,
        id: rfq.id,
        unit_of_measures: this.fb.array(uoms),
      }),
    });
  }

  onUpdateLineTotal(event :Event, index :number) :void {
    const control = this.kitItemsControl.at(index);

    control.patchValue({
      lineTotal: control.value.quantity * control.value.price,
    });
  }

  get kitItemsControl() :UntypedFormArray {
    return this.form.get('kitItems') as UntypedFormArray;
  }

  get isKit() :boolean {
    return this.form.get('type')?.value === EProductTypes.KIT;
  }

  get totalSellingPrice() :number {
    let total = 0;
    this.kitItemsControl.value.forEach((item :any) => {
      total += item.quantity * item.price;
    });

    return total;
  }

  get totalOriginalPrice() :number {
    let total = 0;
    this.kitItemsControl.value.forEach((item :any) => {
      total += item.quantity * item.originalPrice;
    });

    return total;
  }
}
